module.exports = __webpack_public_path__ + "img/create.789da2d2.jpg";